import React, { useState } from 'react';
import { Icon, useBoolean } from '@wegroup/design-system';
import { useTranslation } from 'react-i18next';
import CompanySuccessActionBox from '../../../../risk-analysis/src/pages/recommendations/CompanySuccessActionBox';
// import CompleteSendMailModal from '../../../../advisory-report/src/features/complete/components/CompleteSendMailModal';
import { generateDocumentForReport } from '../../../../advisory-report/src/features/complete/api/documentGeneration';
import { useLocale } from '../../../../../i18n';
// import { useParty } from '../../../../parties/src/features/detail/api/getParty';

interface Props {
  reportId?: string;
  partyId: string;
  partyEmail?: string;
}

const TechniekNederlandFinalizeBody: React.FC<Props> = ({
  reportId,
  partyId,
  partyEmail,
}) => {
  const { t } = useTranslation();
  const [downloadUrl, setDownloadUrl] = useState<string>();
  const [isGenerating, setIsGenerating] = useBoolean();
  const { userLang } = useLocale();
  // const { isOpen, onOpen, onClose } = useDisclosure();
  // const { data: partyData, isLoading: isLoadingParty } = useParty(
  //   !partyEmail ? partyId : undefined,
  // );

  const handleGenerateDocumentExport = async () => {
    if (!reportId) return;
    setIsGenerating.on();
    try {
      const data = await generateDocumentForReport(reportId, 'pdf', userLang);
      if (data.link) {
        setDownloadUrl(data.link);
      }
    } catch {
      console.error(
        'Something went wrong while generating advisory report PDF',
      );
    }
    setIsGenerating.off();
  };

  const handleDownload = () => {
    if (!downloadUrl) return;
    const a = document.createElement('a');
    a.style.display = 'none';
    a.target = '_blank';
    a.href = downloadUrl;
    a.setAttribute('download', '');
    document.body.appendChild(a);
    a.click();
    a.remove();
  };

  return (
    <>
      {/* {reportId && (
        <CompleteSendMailModal
          isOpen={isOpen}
          onClose={onClose}
          reportId={reportId}
          partyEmail={partyEmail || partyData?.email}
          partyId={partyId}
          onEmailSent={() => null}
        />
      )} */}
      <CompanySuccessActionBox
        icon={<Icon name="GeneralActionsDownload" boxSize="6" />}
        isLoading={isGenerating}
        title={t('FLOWS_RECOMMENDATIONS_DOWNLOAD-ADVISORY-REPORT_TITLE')}
        buttonText={
          downloadUrl
            ? t('FLOWS_RECOMMENDATIONS_DOWNLOAD-ADVISORY-REPORT_TITLE')
            : t('FLOWS_RECOMMENDATIONS_GENERATE-ADVISORY-REPORT_TITLE')
        }
        description={t('FLOWS_RECOMMENDATIONS_DOWNLOAD-ADVISORY-REPORT_DESC')}
        onClick={downloadUrl ? handleDownload : handleGenerateDocumentExport}
        isDisabled={!reportId}
        data-test-id="COMPANY-SCAN_RECOMMENDATIONS_CREATE-ADVISORY-REPORT_BUTTON"
      />
      {/* <CompanySuccessActionBox
        icon={<Icon name="GeneralActionsSendEmail" />}
        title={t('FLOWS_RECOMMENDATIONS_EMAIL-ADVISORY-REPORT_TITLE')}
        buttonText={t('FLOWS_RECOMMENDATIONS_EMAIL-ADVISORY-REPORT_TITLE')}
        description={t('FLOWS_RECOMMENDATIONS_EMAIL-ADVISORY-REPORT_DESC')}
        onClick={onOpen}
        isDisabled={!reportId}
        isLoading={isLoadingParty}
        data-test-id="COMPANY-SCAN_RECOMMENDATIONS_CREATE-ADVISORY-REPORT_BUTTON"
      /> */}
    </>
  );
};

export default TechniekNederlandFinalizeBody;
